import { useEffect } from 'react';
import { initializeAuth } from '../actions/auth.actions.js';
import '../auth.store.js';
import '../cognito/cognito.helper.js';

const useAuthInitialization = ()=>{
    useEffect(()=>{
        initializeAuth();
    }, []);
};

export { useAuthInitialization as default };
//# sourceMappingURL=useInitializeAuth.js.map
